import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tianjia",
  "use": "icon-tianjia-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tianjia\"><path fill=\"#515151\" d=\"M692.5 538h-84.65v-78a32 32 0 1 0-64 0v78H460.5a32 32 0 0 0 0 64h83.35v90a32 32 0 0 0 64 0v-90h84.65a32 32 0 0 0 0-64zM928 912H225a32 32 0 0 1-32-32V272a32 32 0 0 1 32-32h703a32 32 0 0 1 32 32v608a32 32 0 0 1-32 32z m-663-72h623V312H265zM241.87 768H95.5a32 32 0 0 1-32-32V144a32 32 0 0 1 32-32h689a32 32 0 0 1 32 32v158.47h-72V184h-609v512h106.37z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol